<script>
import DropdownMenu from 'element-ui/lib/dropdown-menu';

export default DropdownMenu;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/dropdown-menu.css';
// @import "../../stylesheets/utils/utils";
</style>
